import React from "react";

import { faThumbTack } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tooltip from "antd/lib/tooltip";

import CumulDashboard from "@mapmycustomers/shared/types/cumul/CumulDashboard";

import styles from "./DashboardName.module.scss";

const getDashboardName = (name: CumulDashboard["name"]) => (
  <Tooltip placement="top" title={name.en}>
    <div className={styles.pinnedDashbaord}>
      <div className={styles.pinnedDashboardName}>{name.en}</div>
      <FontAwesomeIcon className={styles.pinnedIcon} icon={faThumbTack} />
    </div>
  </Tooltip>
);

export default getDashboardName;
